export function getEmailInitial(email?: string | null): string {
    return email?.[0]?.toUpperCase() ?? '';
}
